import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("批量交付")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("交付超期")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("成本超额")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("填写备注 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看备注")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认交付")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定 ")
const _hoisted_12 = {
  key: 0,
  style: {"color":"red"}
}

import { ref, Ref, reactive, onBeforeMount, inject,getCurrentInstance} from 'vue'
import {useStore} from "vuex";
import { ElMessage, ElMessageBox, } from 'element-plus'
import dayjs from 'dayjs'
import OrderUploadList from './OrderUploadList.vue'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let instance: any = getCurrentInstance()
const globalProperties = instance.appContext.config.globalProperties
const {
  'POST/order/delivery/query': fetchList,
  'GET/isAdmin': isAdminApi,
  // 批量交付
  'POST/order/delivery/batch_delivery': batchDeliveryApi,
  // 订单交付_获取最新数据
  'GET/order/delivery/query_latest_data': query_latest_dataApi,
  //添加或更新备注
  'POST/order/delivery/comment': addOrUpdateCommentApi,
  'POST/order/comment/list': orderCommentsApi,
} = Api
const tableHeight = window.innerHeight
const viewsLoading: any= inject('viewsLoading')
const store=useStore()
let selectionRows = ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchElement = ref()
const searchFormObject = reactive({
  customerUsername: '',
  no: '',
  name: '',
  creator: '',
  poNumber: '',
  pm: '',
  expireEventOrder:false,
  costEventOrder:false,
})

const searchHandle = () => {
  searchFormObject.costEventOrder=false
  searchFormObject.expireEventOrder=false
  fetchData({
    query: searchFormObject
  })
}

searchHandle()


// 订单交付
const orderDeliveryEle = ref()
let deliverRows: any = ref([])
const isShowDeliver = ref<boolean>(false)
const batchDeliveryHandle = () => {
  if(selectionRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  // 判断客户名是否不一致
  if(Array.from(new Set(selectionRows.value.map(e => e.customerUsername))).length > 1){
    ElMessage.warning('请勾选同一客户的订单进行批量交付！')
    return
  }

  deliverRows.value = selectionRows.value
  isShowDeliver.value = true
}

const deliveryHandle = () => {
  const isRight = orderDeliveryEle.value.deliveryOrderHandle()
  
  isRight.then((noList: number[]) => {
    if(noList.length === 0) return Promise.reject();
    MI_identify.value = true
    return batchDeliveryApi({ noList })
    
  }).then(() => {
    MI_identify.value = false
    searchHandle()
    ElMessage.success('交付成功')
    isShowDeliver.value = false
  }).catch(() => {
    MI_identify.value = false
  })
  /* if(!isRight) return;
  MI_identify.value = true
  batchDeliveryApi({
    noList: deliverRows.value.map((row: any) => row.no)
  }).then(() => {
    MI_identify.value = false
    searchHandle()
    ElMessage.success('交付成功')
    isShowDeliver.value = false
  }).finally(() => {
    MI_identify.value = true
  }) */
}



// 获取最新数据
const btnLoading = ref<boolean>(false)
const getLastDataHandle = () => {
  btnLoading.value = true
  ElMessage('正在获取中')
  query_latest_dataApi({}, {timeout: 0}).finally(() => {
    btnLoading.value = false
  })
}
const calRowClass = ({row, rowIndex}: any) => {
  if (!row.isHadEvent&&(row.costControl==2||row.overdueDays>7)) {
    return " problem-order "
  }
  return ""
}
const fetchExpireEventOrder=()=>{
  searchElement.value.resetFields();
  searchFormObject.expireEventOrder=true
  searchFormObject.costEventOrder=false
  fetchData(searchFormObject)
}
const fetchCostEventOrder=()=>{
  searchElement.value.resetFields();
  searchFormObject.expireEventOrder=false
  searchFormObject.costEventOrder=true
  fetchData(searchFormObject)
}
const isAdmin = ref<boolean>(false)

onBeforeMount(() => {
  isAdminApi().then((rep: boolean) => {
    isAdmin.value = rep
  })
})
const isPMOrLeader = (row: any) => {
  const userName = store.getters.userName.toLowerCase();
  const itemPm = row.pm.toLowerCase();
  if (userName.indexOf("(") >= 0) {
    return isAdmin.value ||
        (itemPm == userName) ||
        ((row.leaderId == store.getters.userId)) ||
        (itemPm == userName.substr(0, userName.indexOf("("))) ||
        (itemPm == userName.substr(userName.indexOf("(") + 1).replace(")", ""))
  }
  return isAdmin.value || (itemPm == userName) || ((row.leaderId == store.getters.userId))
}
const needShowAddCommentBtn = (row: any) => {
  if (isPMOrLeader(row)) {
    return row.events.length > 0
  }
  return false
}
let addOrUpdateCommentParamsObj = reactive<{ id: number | null, orderId: number, event: string, msg: string,sourceType:string }>({
  id: null,
  orderId: 0,
  event: '',
  msg: '',
  sourceType:'ORDER_DELIVERY'
})

let orderCostDialogInfo = reactive({
  isShow: false,
  loading: false,
  error: '',
  data: []
})

let orderCommentsDialogInfo = reactive<{ isShow: boolean, loading: boolean, error: string, data: any, order: any }>({
  isShow: false,
  loading: false,
  error: '',
  data: [],
  order: undefined
});
let addOrUpdateCommentDialogInfo = reactive<{ isShow: boolean, order: object | null, loading: boolean }>({
  isShow: false,
  order: null,
  loading: false
})
const addOrUpdateForm = ref()
const showAddOrUpdateCommentDialog = async (row: any, comment: any) => {
  addOrUpdateCommentParamsObj.id = comment ? comment.id : null
  addOrUpdateCommentParamsObj.event = comment ? comment.event : ''
  addOrUpdateCommentParamsObj.orderId = row.id
  addOrUpdateCommentParamsObj.msg = comment ? comment.msg : ''
  addOrUpdateCommentDialogInfo.order = row
  orderCommentsDialogInfo.data =await orderCommentsApi({id: row.id,sourceType:'ORDER_DELIVERY'})
  addOrUpdateCommentDialogInfo.isShow = true
  setTimeout(() => {
    addOrUpdateForm.value.clearValidate();
  }, 50)
}
const showComment = (row: any) => {
  orderCommentsDialogInfo.loading = true
  orderCommentsDialogInfo.error = ''
  orderCommentsDialogInfo.data = []
  orderCommentsDialogInfo.isShow = true
  orderCommentsDialogInfo.order = row
  orderCommentsApi({id: row.id,sourceType:'ORDER_DELIVERY'}).then((r: any) => {
    orderCommentsDialogInfo.loading = false
    orderCommentsDialogInfo.data = r
  }).catch((e: any) => {
    orderCommentsDialogInfo.loading = false
    orderCommentsDialogInfo.error = "加载失败，请关闭重试"
  })
}
const addOrUpdateComment = () => {
  addOrUpdateForm.value.validate((valid: boolean) => {
    if (valid) {
      addOrUpdateCommentDialogInfo.loading = true
      addOrUpdateCommentApi(addOrUpdateCommentParamsObj).then((r: any) => {
        addOrUpdateCommentDialogInfo.loading = false
        const filtered = MI_tableData.value.filter((i: any) => i.id == addOrUpdateCommentParamsObj.orderId);
        if (filtered.length > 0) {
          filtered[0].events = filtered[0].events.filter((i: string) => i != addOrUpdateCommentParamsObj.event);
        }
        if (orderCommentsDialogInfo.order && orderCommentsDialogInfo.order.id && (orderCommentsDialogInfo.order.id == addOrUpdateCommentParamsObj.orderId)) {
          showComment(orderCommentsDialogInfo.order)
        }
        globalProperties.$message.success(addOrUpdateCommentParamsObj.id ? '添加备注成功' : '修改备注成功')
        addOrUpdateCommentDialogInfo.isShow = false        
      }).catch((e: any) => {
        addOrUpdateCommentDialogInfo.loading = false
        globalProperties.$message.error((addOrUpdateCommentParamsObj.id ? '添加备注失败' : '修改备注失败') + e)
      })
    } else {
      return false
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "订单交付列表-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              "label-position": "left",
              model: _unref(searchFormObject),
              class: "searchBg",
              inline: true,
              ref_key: "searchElement",
              ref: searchElement,
              "label-width": "100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "客户名称:",
                  prop: "customerUsername"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      maxlength: "200",
                      modelValue: _unref(searchFormObject).customerUsername,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchFormObject).customerUsername) = $event)),
                      placeholder: "请输入客户名称",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "订单号:",
                  prop: "no"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      maxlength: "200",
                      modelValue: _unref(searchFormObject).no,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchFormObject).no) = $event)),
                      placeholder: "请输入订单号",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "订单名称:",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      maxlength: "200",
                      modelValue: _unref(searchFormObject).name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchFormObject).name) = $event)),
                      placeholder: "请输入订单名称",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户经理:",
                  prop: "creator"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      maxlength: "200",
                      modelValue: _unref(searchFormObject).creator,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchFormObject).creator) = $event)),
                      placeholder: "请输入客户经理",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "PO号:",
                  prop: "poNumber"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      maxlength: "200",
                      modelValue: _unref(searchFormObject).poNumber,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchFormObject).poNumber) = $event)),
                      placeholder: "请输入PO号",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "PM:",
                  prop: "pm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      maxlength: "200",
                      modelValue: _unref(searchFormObject).pm,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchFormObject).pm) = $event)),
                      placeholder: "请输入PM",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (searchHandle()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (searchElement.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[8] || (_cache[8] = ($event: any) => (batchDeliveryHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      type: "primary",
      loading: _unref(MI_identify),
      onClick: fetchExpireEventOrder
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_el_button, {
      type: "primary",
      loading: _unref(MI_identify),
      onClick: fetchCostEventOrder
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["loading"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      data: _unref(MI_tableData),
      class: "mt-10",
      "row-class-name": calRowClass,
      onSelectionChange: _cache[9] || (_cache[9] = (rows) => _isRef(selectionRows) //@ts-ignore
 ? selectionRows.value = rows : selectionRows = rows),
      "max-height": _unref(MI_height) - 60 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "50",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单号",
          prop: "no",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单名",
          prop: "name",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户名",
          prop: "customerUsername",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "联系人",
          prop: "customerContactor",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "PO号",
          prop: "poNo",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "PM交付时间",
          prop: "projectFileDeliverTime",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "超期（天）",
          prop: "overdueDays",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户经理",
          prop: "creator",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "PM",
          prop: "pm",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "AM",
          prop: "am",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "USD金额",
          prop: "baseCurrencyMoney",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "原币别",
          prop: "currency",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "原金额",
          prop: "amount",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "成本",
          prop: "rtAmount",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "160"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  disabled: !needShowAddCommentBtn(row),
                  onClick: ($event: any) => (showAddOrUpdateCommentDialog(row,null))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]),
                _createVNode(_component_el_link, {
                  disabled: !isPMOrLeader(row)||row.handledEventCount<1,
                  onClick: ($event: any) => (showComment(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      class: "mt-10",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-sizes": [30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowDeliver.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((isShowDeliver).value = $event)),
      title: "订单交付",
      fullscreen: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (isShowDeliver.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (deliveryHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (isShowDeliver.value)
          ? (_openBlock(), _createBlock(OrderUploadList, {
              key: 0,
              "order-list": _unref(deliverRows),
              ref_key: "orderDeliveryEle",
              ref: orderDeliveryEle
            }, null, 8, ["order-list"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: _unref(addOrUpdateCommentParamsObj).id?'修改备注':'添加备注',
      modelValue: _unref(addOrUpdateCommentDialogInfo).isShow,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(addOrUpdateCommentDialogInfo).isShow) = $event)),
      width: "900",
      center: "",
      draggable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            class: "addCommentDialog",
            ref_key: "addOrUpdateForm",
            ref: addOrUpdateForm,
            model: _unref(addOrUpdateCommentParamsObj),
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "备注事件",
                prop: "event",
                required: "",
                rules: [{required:true,message:'请选择备注事件'}]
              }, {
                default: _withCtx(() => [
                  (_unref(addOrUpdateCommentParamsObj).id)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: _unref(addOrUpdateCommentParamsObj).event,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(addOrUpdateCommentParamsObj).event) = $event)),
                        placeholder: "请选择备注事件"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _unref(addOrUpdateCommentParamsObj).event,
                            value: _unref(addOrUpdateCommentParamsObj).event
                          }, null, 8, ["label", "value"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_el_select, {
                        key: 1,
                        modelValue: _unref(addOrUpdateCommentParamsObj).event,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(addOrUpdateCommentParamsObj).event) = $event)),
                        placeholder: "请选择备注事件"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addOrUpdateCommentDialogInfo).order.events, (event, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: event,
                              label: event,
                              value: event
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "备注内容:",
                prop: "msg",
                required: "",
                rules: [{required:true,message:'请输入备注内容'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    clearable: "",
                    modelValue: _unref(addOrUpdateCommentParamsObj).msg,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(addOrUpdateCommentParamsObj).msg) = $event)),
                    type: "textarea",
                    rows: 3,
                    placeholder: "请输入备注类容"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (addOrUpdateComment())),
                    disabled: _unref(addOrUpdateCommentDialogInfo).loading,
                    loading: _unref(addOrUpdateCommentDialogInfo).loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_el_table, {
            data: _unref(orderCommentsDialogInfo).data,
            style: {"width":"100%","margin-top":"-12px"},
            "empty-text": "暂无备注",
            border: "",
            "max-height": 400
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "event",
                label: "事件",
                width: "200",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(`${row.sourceType=='ORDER_DELIVERY'?'[订单交付]':'项目交付'}${row.event}`), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "createdAt",
                label: "填写时间",
                width: "180",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "commenter",
                label: "填写人",
                width: "160",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "msg",
                label: "备注",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "订单备注",
      class: "order-comment-dialog",
      modelValue: _unref(orderCommentsDialogInfo).isShow,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(orderCommentsDialogInfo).isShow) = $event)),
      width: "900",
      center: "",
      draggable: ""
    }, {
      footer: _withCtx(() => [
        (_unref(orderCommentsDialogInfo).error.length>0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(orderCommentsDialogInfo).error), 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _unref(orderCommentsDialogInfo).data,
          style: {"width":"100%"},
          "empty-text": "暂无备注",
          border: "",
          "max-height": 400
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "event",
              label: "事件",
              width: "200",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(`${row.sourceType=='ORDER_DELIVERY'?'[订单交付]':'项目交付'}${row.event}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "createdAt",
              label: "填写时间",
              width: "180",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "commenter",
              label: "填写人",
              width: "160",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "msg",
              label: "备注",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})